module.exports = __webpack_public_path__ + "static/media/NESTLEIND_F1.a5ee1ae6.txt";